<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <form @submit.prevent="save">
                    <div class="card">
                        <div class="card-header">
                            <i class="fa fa-user"></i> Credenciada
                        </div>
                        <div class="card-block form form-horizontal">
                            <div class="form-group row">
                              <div
                                  class="col-md-4"
                                  :class="{ 'dropdown-has-error': $v.model.id_pais.$error }"
                              >
                                  <label>País*</label>
                                  <select-api
                                      ref="selectPais"
                                      v-model="model.id_pais"
                                      :endpoint="'/pais/pesquisa'"
                                      :opt-text="'nome'"
                                      :select-option="true"
                                  ></select-api>
                              </div>

                              <div
                                  class="col-md-4"
                                  :class="{ 'dropdown-has-error': $v.model.tipo.$error }"
                              >
                                <label>Tipo*</label>
                                <Select2
                                    placeholder="Selecione"
                                    v-model="model.tipo"
                                    :options="tipos"
                                    opt-id="tipo"
                                >
                                    <option value selected>Selecione</option>
                                </Select2>
                              </div>
                            </div>

                            <div class="form-group row">
                                <div
                                    class="col-md-4"
                                    :class="{ 'has-danger': $v.model.nome.$error }"
                                >
                                    <label>Nome*</label>
                                    <input type="text" class="form-control" v-model="model.nome" />
                                </div>

                                <div class="col-md-4">
                                    <label>Telefone</label>
                                    <input type="text" class="form-control" maxlength="20" v-model="model.telefone" />
                                </div>

                                <div class="col-md-4">
                                    <label>E-mail</label>
                                    <input type="email" class="form-control" v-model="model.email" />
                                </div>
                            </div>

                            <div class="form-group row">
                              <div class="col-md-6">
                                  <label>Site</label>
                                  <input type="text" class="form-control" v-model="model.site" />
                              </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label>Descrição</label>
                                    <dw-textarea
                                        v-model="model.descricao"
                                        @input="$v.model.descricao.$touch()"
                                    ></dw-textarea>
                                </div>
                                <div class="col-md-4">
                                    <label>Horário</label>
                                    <dw-textarea
                                        v-model="model.horario"
                                        @input="$v.model.horario.$touch()"
                                    ></dw-textarea>
                                </div>
                                <div class="col-md-4">
                                    <label>Procedimento</label>
                                    <dw-textarea
                                        v-model="model.procedimento"
                                        @input="$v.model.procedimento.$touch()"
                                    ></dw-textarea>
                                </div>
                            </div>

                            <div class="alert alert-warning">
                                <strong>Atenção!</strong>
                                O tamanho máximo e indicado para a
                                <strong>Imagem</strong> é de
                                <strong>300kb</strong>.
                            </div>
                            <div class="form-group row">
                                <div class="col-md-12">
                                    <file-image
                                        v-model="imagem"
                                        :label="'Imagem'"
                                        :arquivo="model.arquivo"
                                    ></file-image>
                                </div>
                            </div>
                        </div>
                    </div>

                    <dw-form-address
                      :pais="pais"
                      :id-pais="model.id_pais"
                      v-bind:model="model.endereco"
                      ref="formAddress">
                    </dw-form-address>

                    <div class="card">
                        <div class="card-footer text-right">
                            <router-link :to="{ name: 'list-clinic' }" class="btn btn-link">Cancelar</router-link>

                            <button type="submit" class="btn btn-primary">Salvar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import Facade from "../../facade/facade";

const facade = new Facade();

import {
    required,
    minLength,
    maxLength,
    withParams,
    email
} from "vuelidate/lib/validators";
import {
    isUndefinedOrNullOrEmpty,
    isNotUndefinedOrNullOrEmptyOrZero,
    formatPhone,
    formatCpf,
    formatCep,
    clearCpfCnpj
} from "@/services/string";
import { isPhone, isCpf, validateCPF } from "@/services/util";
import Collections from "../../helpers/collections";
import SelectApi from "../../components/Input/SelectApi";
import FileImage from "../../components/Input/FileImage";
import Select2 from '../../components/Input/Select2';

export default {
    components: {
        FileImage, SelectApi, Select2
    },
    data() {
        return {
            model: {
                tipo: '',
                nome: "",
                telefone: "",
                email: "",
                descricao: "",
                horario: "",
                procedimento: "",
                site: '',
                endereco: {
                    logradouro: "",
                    numero: "",
                    complemento: "",
                    bairro: "",
                    id_estado: "0",
                    id_cidade: "0",
                    cep: ""
                },
                id_pais: ''
            },
            sexos: [],
            tipos: [],
            imagem: null
        };
    },
    computed: {
      pais: function () {
        let vm = this;
        let select = this.$refs.selectPais;
        if (select && select.list) {
          return _.find(select.list, (item) => {
              return item.id == vm.model.id_pais
          })
        }
        return null;
      }
    },
    validations() {
        return {
            model: {
                nome: {
                    required
                },
                id_pais: {
                    required,
                    isNotUndefinedOrNullOrEmptyOrZero
                },
                tipo: {
                    required,
                    isNotUndefinedOrNullOrEmptyOrZero
                }
            }
        };
    },
    methods: {
        async save() {
            let vm = this;
            if (this.$v.model.$invalid || this.$refs.formAddress.isInvalid()) {
                this.$v.model.$touch();
                this.$refs.formAddress.isInvalid();
                this.$notify.warning(
                    "Atenção!",
                    "Verifique se todos os campos estão preenchidos corretamente."
                );
                return;
            }

            this.$loading.show(true);

            try {
              const formData = new FormData();
              formData.append("data", JSON.stringify(vm.model));
              formData.append("imagem", vm.imagem);

              if (vm.model.id) {
                  await facade.updateClinic(formData, vm.model.id);
              } else {
                  await facade.createClinic(formData);
              }

              this.$router.push({ name: "list-clinic" });
            } catch (e) {
                e.forEach(item => {
                    this.$notify.error(item.field, item.message);
                });
                this.$loading.show(false);
            }
        },
        throwError(e) {
            this.$notify.error("Erro!", e);
        },
        setData(clinic) {
            if (clinic !== undefined && clinic !== null) {
                // clinic.telefone = clinic.telefone
                //     ? formatPhone(clinic.telefone)
                //     : "";

                this.model = clinic;
            }
            this.sexos = Collections.sexos;
            this.tipos = Collections.tipoClinica;
        }
    },
    beforeRouteEnter(to, from, next) {
        const vm = this;
        Promise.all([to.params.id ? facade.getClinic(to.params.id) : null])
            .then(response => {
                next(vm =>
                    vm.setData(
                        response[0] != null ? response[0].data.data : null
                    )
                );
            })
            .catch(e => {
                next(vm => vm.setData());
            });
    }
};
</script>



// WEBPACK FOOTER //
// Form.vue?87567d66